// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "Variable" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { VariableType } from "./variable-type.enum.gen";
import { OrganisationGenShape } from "./organisation.gen";

export const VariableGenShape = z.strictObject({
  key: z.string(),
  varType: z.enum(VariableType),
  name: z.string(),
  description: z.string(),
  optional: z.boolean().optional(),
  value: z.string().optional(),
  linkText: z.string().optional(),
  organisations: z.array(OrganisationGenShape).optional(),
  template: z.string().optional(),
  masterId: z.string().nullable().default(null),
  tagId: z.string().nullable().default(null),
  libraryId: z.string(),
  created: z.string().optional(),
  createdUserId: z.string().optional(),
  lastEdited: z.string().optional(),
  lastEditedUserId: z.string().optional(),
  id: z.string(),
});
